---
title: "Ich habe 50 Kindergärten mit Klettergerüsten ausgestattet"
slug: "50-kindergaerten-klettergerueste"
date: "2024-01-13"
excerpt: "Ich habe 50 Kindergärten mit Klettergerüsten ausgestattet ☺️ Ich habe die komplette Rechnung übernommen - ca 350k€), weil ich etwas zurückgeben möchte von dem was ich als Bürger Deutschlands ständig an Infrastruktur, Angeboten und Unterstützungen erfahren habe."
metaTitle: "50 Kindergärten mit Klettergerüsten ausgestattet | Kevin Rassner"
metaDescription: "Warum ich 350k€ Steuern zahle und stolz darauf bin: Ein Plädoyer dafür, Steuern als Beitrag zur Gesellschaft zu sehen und 'Giving Back' wieder sexy zu machen."
language: "de"
author: "Kevin Rassner"
authorUrl: "https://rassner-dev.org"
linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7152023830352318465"
isLinkedInPost: true
---

Ich habe 50 Kindergärten mit Klettergerüsten ausgestattet ☺️

Ich habe die komplette Rechnung übernommen - ca 350k€), weil ich etwas zurückgeben möchte von dem was ich als Bürger Deutschlands ständig an Infrastruktur, Angeboten und Unterstützungen erfahren habe. Ich habe das getan, nicht weil ich konnte, sondern tatsächlich, weil ich musste. Nennt sich Einkommenssteuer - und ich finds klasse 🥰

Ich finde, Steuern zahlen und der Gesellschaft etwas zurückgeben muss (wieder?) sexy werden. Warum lesen wir in Forbes über die reichsten Deutschen und nicht die größten Steuerzahler? Warum rühmt man sich als Bürger eher damit wie man Steuern sparen konnte, als damit, was man aller ermöglicht hat?

Ist keine brillante Idee, aber fändet ihr es nicht auch irgendwie toll, am Ende des Jahres eine Anerkennung dafür zu kriegen, was man geleistet hat („mit Ihren Steuergeldern der letzten 4 Jahre konnte eine Sozialwohnung für eine 5-köpfige Familie in Not errichtet werden“). Gibt’s da vielleicht schon eine NGO zu? Fände ich super!

Wofür würdet ihr euer Steuergeld am liebsten (symbolisch) einsetzen?

Die Klettergerüste habe ich übrigens in meinem gesamten Arbeitsleben bezahlt, nicht nur in 2023. leider 😄

